import { render, staticRenderFns } from "./photo-bak.vue?vue&type=template&id=2e90513d&scoped=true&"
import script from "./photo-bak.vue?vue&type=script&lang=js&"
export * from "./photo-bak.vue?vue&type=script&lang=js&"
import style0 from "./photo-bak.vue?vue&type=style&index=0&id=2e90513d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e90513d",
  null
  
)

export default component.exports